var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import styles from './Typography.module.scss';
import { logDevelopmentMessage } from '../../utils/logDevelopmentMessage';
import { useIngredientsStyleOptionsContext } from '../../contexts/IngredientsStyleOptionsProvider';
export var stylesWithFixableSize = [
    'headingLarge',
    'headingLargeLight',
    'headingLight',
    'screenHeading',
    'sectionHeading',
    'sectionHeadingLight',
    'sectionHeadingSmall',
];
var TypographyComponent = function (_a, ref) {
    var _b;
    var _c;
    var element = _a.element, _d = _a.fixedSize, fixedSize = _d === void 0 ? false : _d, component = _a.component, _e = _a.styleAs, styleAs = _e === void 0 ? 'paragraph' : _e, className = _a.className, _f = _a.noMargins, noMargins = _f === void 0 ? false : _f, _g = _a.noWrap, noWrap = _g === void 0 ? false : _g, props = __rest(_a, ["element", "fixedSize", "component", "styleAs", "className", "noMargins", "noWrap"]);
    var Element = element || component || 'p';
    var styleOptionsContext = useIngredientsStyleOptionsContext();
    var styleOptionsClasses = (_c = styleOptionsContext.options) === null || _c === void 0 ? void 0 : _c.reduce(function (accumulator, styleOption) {
        var _a;
        return (__assign(__assign({}, accumulator), (_a = {}, _a[styles[styleOption]] = true, _a)));
    }, {});
    var classNames = cx(styles.typography, styleOptionsClasses, styles[styleAs], (_b = {},
        _b[styles.noMargins] = noMargins,
        _b[styles.noWrap] = noWrap,
        _b[styles.fixedSize] = fixedSize,
        _b), className);
    if (fixedSize && !stylesWithFixableSize.includes(styleAs)) {
        logDevelopmentMessage('Typography: fixedSize property can be only used on specific styles.');
    }
    return React.createElement(Element, __assign({ ref: ref, className: classNames }, props));
};
/**
 * @tdr
 * @tdr-candidates: p,h1,h2,h3,h4,h5,h6
 */
export var Typography = forwardRef(TypographyComponent);
//# sourceMappingURL=Typography.js.map